export {
  LEARN_SUMMARY_CONTENT_BOTTOM_INSET,
  LEARN_SUMMARY_CTA_BOTTOM_GAP,
} from "#learn-summary-content-bottom-inset";
